import { render, staticRenderFns } from "./MonthData.vue?vue&type=template&id=1472464f&scoped=true&"
import script from "./MonthData.vue?vue&type=script&lang=js&"
export * from "./MonthData.vue?vue&type=script&lang=js&"
import style0 from "./MonthData.vue?vue&type=style&index=0&id=1472464f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472464f",
  null
  
)

export default component.exports